module.exports = __webpack_public_path__ + "assets/img/index-gl_zh-CN.07e3ae23.png";